import React from 'react'
import NakedButton from '@Components/Buttons/NakedButton'
import { useLocation, useNavigate } from 'react-router'

interface ViewWorkBackButtonProps {
    text?: string
}
const BackButton = (props: ViewWorkBackButtonProps) => {
    const navigate = useNavigate()
    const location = useLocation()
    const canGoBack = location.key !== 'default'
    const backTo = location.state?.referrer ?? undefined
    const { text } = props

    return (
        <>
            {canGoBack && (
                <NakedButton
                    onClick={() => {
                        backTo ? navigate(backTo, { state: { referrer: location.pathname } }) : navigate(-1)
                    }}
                >
                    {text ?? '< Back'}
                </NakedButton>
            )}
        </>
    )
}

export default BackButton
